// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"55e53b87","231":"aacdc090","272":"f5500883","279":"be60a706","453":"ba44c00d","539":"17b09044","579":"db6091ea","693":"301d61aa"}[chunkId] + ".chunk.js";
};